import { CmsApiCategoryHighlightBlockData } from 'modules/cms/api/types/blocks/CmsApiCategoryHighlightBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpCategoryHighlightBlock } from './CmsAmpCategoryHighlightBlock';
import { CmsCategoryHighlightBlock } from './CmsCategoryHighlightBlock';

export const CategoryHighlightBlockMapping: CmsBlockMapping<CmsApiCategoryHighlightBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsCategoryHighlightBlock,
    AmpComponent: CmsAmpCategoryHighlightBlock,
  };
